/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { PageNotification } from '@coursera/cds-core';

import type { SaveNotificationType } from 'bundles/author-assignment-grading/constants/SaveNotificationTypes';
import SaveNotificationTypes from 'bundles/author-assignment-grading/constants/SaveNotificationTypes';

import _t from 'i18n!nls/grading';

type Props = {
  notificationType: SaveNotificationType | null;
  onDismiss: () => void;
};

const styles = {
  container: css`
    position: relative;
    margin: 0 var(--cds-spacing-600);
  `,
  notification: css`
    position: absolute;
    right: 0;
    width: 100%;
    z-index: 4;
  `,
};

// Component for legacy GraderModuleSaveButton status change notifications
const SaveNotification = ({ notificationType, onDismiss }: Props) => {
  if (!notificationType) {
    return null;
  }

  const isSuccess = notificationType === SaveNotificationTypes.SUCCESS;
  const title = isSuccess ? _t('Saved successfully') : _t('Unable to save changes');
  const text = isSuccess
    ? _t('Your change was saved successfully!')
    : _t('There was an error saving your changes. Please try again.');

  return text ? (
    <div data-testid="item-setting-exceptions-save-notification" css={styles.container}>
      <PageNotification
        severity={isSuccess ? 'success' : 'error'}
        title={title}
        css={styles.notification}
        onDismiss={onDismiss}
      >
        {text}
      </PageNotification>
    </div>
  ) : null;
};

export default SaveNotification;
